export class InvoiceFilterConfig {
    constructor(
        public FilterOnNumber: boolean = false,
        public FilterOnSupplier: boolean = false,
        public FilterOnPrimaryReference: boolean = false,
        public FilterOnRecipientEntity: boolean = false,
        public FilterOnInvoiceDate: boolean = false,
        public FilterOnProcessingDate: boolean = false,
        public FilterOnReceptionDate: boolean = false,
        public FilterOnReverseFactoring: boolean = false,
        public FilterOnWorkingSituation: boolean = false,
        public FilterOnControl: boolean = false,
        public FilterOnPicked: boolean = false,
        public FilterOnRejectionType: boolean = false,
        public FilterOnValidationTypes: boolean = false,
        public FilterOnSageErpCode: boolean = false,
        public FilterOnDueDate: boolean = false,
        public FilterOnInvoiceWaitingFlags: boolean = false,
        public FilterOnComplaint: boolean = false,
        public FilterOnExpenseFamilyTypes: boolean = false,
        public FilterOnExpenseTradeTypes: boolean = false,
    ) {}
}
